<template>
<div id="layoutAuthentication">
            <div id="layoutAuthentication_content">
                <main>
                    <div class="container">
                        <div class="row justify-content-center mb-5">
                            <div class="col-lg-7">
                                <div class="card shadow-lg border-0 rounded-lg mt-3">
                                    <div class="card-header"><h3 class="text-center font-weight-light my-2">Create Account</h3></div>
                                    <div class="card-body">
                                        <form @submit.prevent="register_user">
                        
                                                    <div class="form-group">
                                                        <label class="small mb-1" for="inputFirstName">First Name</label>
                                                            <input class="form-control py-4" id="inputFirstName" type="text" placeholder="Enter first name" v-model="form.first_name" required/>
                                                   </div>
                                                
                                                    <div class="form-group">
                                                        <label class="small mb-1" for="inputLastName">Last Name</label>
                                                            <input class="form-control py-4" id="inputLastName" type="text" placeholder="Enter last name" v-model="form.last_name"  required/>
                                                    </div>
                                                    <div class="form-group"><label class="small mb-1" for="inputEmail">
                                                        Email</label>
                                                        <input class="form-control py-4" id="inputEmail" type="email" placeholder="Enter Email" v-model="form.email" required/>
                                                    </div>
                                  
                                                
                                                    <div class="form-group"><label class="small mb-1" for="inputConfirmPassword">Password</label>
                                                        <input class="form-control py-4" id="inputConfirmPassword" type="password" v-model="form.password" required placeholder="Enter password" />
                                                    </div>
                                                <p v-if="message"  class="text-center" style="color: red"> {{message}} </p>
                                            <div class="form-group mt-4 mb-0">
                                                <button type="submit" class="btn btn-primary btn-block">
                                                        Create Account                     
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="card-footer text-center">
                                        <div class="small"><a href="/editor/login">Have an account? Go to login</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div> 
        </div>
</template>
<script>
    import url from '../URL'
export default {
    data() {
        return {
            form: {
                first_name:'',
                last_name:'',
                email:'',
                password:'',
            },
            loading: false,
            message: '',
        }
        },
    methods: {
        termsAndCondition() {
            window.open("http://creativecommons.org/")
            },
        register_user(e) {
            e.preventDefault()
             this.message = ''
             this.loading = true;

             const userData = {
                        "first_name": this.form.first_name,
                        "last_name" : this.form.last_name,
                        "email" : this.form.email ,
                        "password" : this.form.password,
                    } 
            const submitData = async() => {
                 
                 try {
                     const response = await this.$http.post(`${this.apiurl}/api/actioncommons/editor/create`, userData)
                        if(response.status === 201) {
                            localStorage.setItem('editorToken', response.data.token)
                            this.loading = false;
                            this.$router.push("/editor_dashboard/home")
                        } 
                 }catch( err){
                     if(err) {
                         if(err.response.status === 422) {
                         this.loading = false;
                         this.message = "Account already exist"
                     } else if(err.request) {
                         this.loading = false;
                         this.message = "Network Error. Try Again!."
                     }
                     }
                 }
            }
            submitData()
        }
 
    },
    computed: {
    apiurl() {
        return url()
    }
}
}
</script>
<style scope>

</style>